import React, { useEffect, useState } from "react";
import { Button, Card, Rate, Tooltip } from "antd";
import { CheckSquareOutlined, SelectOutlined } from "@ant-design/icons";
import { FaHeart } from "react-icons/fa";
import {
  TbHexagonLetterP,
  TbHexagonLetterR,
  TbHexagonLetterS,
  TbSquareLetterC,
  TbSquareLetterG,
  TbHexagonLetterW,
} from "react-icons/tb";
import secureLocalStorage from "react-secure-storage";
import "../style.css";
import { landCoverTypeLabels, priorityLabels } from "../utils/helperFunctions";

const PrintHelp = ({
  practice,
  currentData,
  currentPriorities,
  selectedTopPracticeList,
  selectedFips,
  layout,
  selectable,
  preferredPractice,
  setPreferredPractice,
  setPreferredSignups,
  setPreferredIncentives,
  userFavoritePractices,
  favOnchange,
  listView,
  selected,
  printView,
}) => {
  const [cardClass, setCardClass] = useState("");

  const isLoggedIn = secureLocalStorage.getItem("token");

  useEffect(() => {
    setCardClass(classNameSelector() + " print");
  }, [preferredPractice]);

  const incentiveMap =
    practice.programs?.reduce((acc, program) => {
      Object.entries(program.incentives || {}).forEach(([key, value]) => {
        if (value && value !== "false" && value !== "NA" && value !== "0") {
          acc[key] = value;
        }
      });
      return acc;
    }, {}) || {};

  const practiceTitle = practice.title.split("-")[0];

  const classNameSelector = () => {
    let myClassName = "practice-card";

    if (listView === "List") {
      myClassName += " list-view";
      if (selected) myClassName += " selected";
    } else if (listView === "Grid") {
      if (selected) myClassName += " selected";
      myClassName += " practice-card-vertical";
    } else {
      if (selected) myClassName += " selected";
      myClassName += " practice-card-horizontal";
    }
    return myClassName;
  };

  useEffect(() => {
    console.log("🧾 Practice: ", practice);
  }, [practice]);

  return (
    <Card
      className={cardClass}
      title={
        <>
          <p className="practice-number">
            {practice.title.split("-")[0]}{" "}
            <div style={{ float: "right" }}>
              {practice.scoreLabel && (
                <span className={practice.scoreClassName}>
                  {practice.scoreLabel}
                </span>
              )}
              {isLoggedIn !== null && (
                <Rate
                  character={
                    <FaHeart
                      color={
                        userFavoritePractices.includes(practice.title)
                          ? "coral"
                          : "lightgray"
                      }
                      style={{ verticalAlign: "middle" }}
                    />
                  }
                  count="1"
                  value={userFavoritePractices.includes(practice.title) ? 1 : 0}
                  onChange={(val) =>
                    favOnchange(val, practice.title + "#" + practice.pdflink)
                  }
                />
              )}
            </div>
          </p>
          <p className="practice-title">{practice.title.split("-")[1]}</p>
        </>
      }
      headStyle={{
        backgroundColor: "#5D1725",
        color: "white",
      }}
    >
      {practice.isMostCommon && (
        <div
          className={
            listView === "Compact" ? "most-common-compact" : "most-common"
          }
        >
          Most Common
        </div>
      )}

      {practice.landcover && (
        <div className="print step2_images">
          <b>Land Cover:</b>
          <ul>
            {practice.landcover.map((p) => (
              <li key={p} title={landCoverTypeLabels[p]}>
                {landCoverTypeLabels[p]}
              </li>
            ))}
          </ul>
        </div>
      )}

      {practice.priorities && (
        <div className="print step3_images">
          <b>Priorities:</b>
          <ul>
            {practice.priorities.map((p) => (
              <li key={p.name} title={priorityLabels[p.name]}>
                {priorityLabels[p.name]}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Signups */}
      <div className="print signup-icons">
        <b>Signups: </b>
        {practice.general && (
          <div className="print signup-icons-inner">
            <span>
              <TbSquareLetterG size="1.5em" color="maroon" />
            </span>
            <p>General</p>
          </div>
        )}
        {practice.continuous === "true" && (
          <div className="print signup-icons-inner">
            <span>
              <TbSquareLetterC size="1.5em" color="maroon" />
            </span>
            <p>Continuous</p>
          </div>
        )}
      </div>

      {/* Incentives */}
      <div className="print incentive-icons">
        <b>Incentives: </b>
        <div className="print incentive-icons-inner">
          {incentiveMap.sip && (
            <Tooltip title="Signup Incentive">
              <TbHexagonLetterS size="2em" color="maroon" />
              <b className="print incentive-percent">{incentiveMap.sip}%</b>
            </Tooltip>
          )}
          {incentiveMap.rentalRateIncentive && (
            <Tooltip title="Rental Rate Incentive">
              <TbHexagonLetterR size="2em" color="maroon" />
              <b className="print incentive-percent">
                {incentiveMap.rentalRateIncentive}%
              </b>
            </Tooltip>
          )}
          {incentiveMap.pip && (
            <Tooltip title="Practice Incentive">
              <TbHexagonLetterP size="2em" color="maroon" />
              <b className="print incentive-percent">{incentiveMap.pip}%</b>
            </Tooltip>
          )}
          {incentiveMap.waterqualitythruclear30 && (
            <Tooltip title="Water Quality Bonus (CLEAR30)">
              <TbHexagonLetterW size="2em" color="maroon" />
              <b className="print incentive-percent">
                {incentiveMap.waterqualitythruclear30}%
              </b>
            </Tooltip>
          )}
        </div>
      </div>

      {selectable && setPreferredPractice && (
        <Button
          className={
            preferredPractice === practice.title.split("-")[0]
              ? "practice-select-button-selected"
              : "practice-select-button"
          }
          onClick={() => {
            setPreferredPractice(practice.title.split("-")[0]);
            setPreferredSignups({
              G: currentData.general,
              C: currentData.continous,
            });
            setPreferredIncentives({
              S: currentData["32_5_p_sip"],
              R: currentData["20_p_rr_incentive"],
              P: currentData["50_p_pip"],
              C: currentData["climate_smrt_incentive"],
            });
          }}
        >
          {preferredPractice === practice.title.split("-")[0] ? (
            <>
              <b>Selected </b>
              <CheckSquareOutlined />
            </>
          ) : (
            <>
              <b>Select </b>
              <SelectOutlined />
            </>
          )}
        </Button>
      )}
    </Card>
  );
};

export default PrintHelp;
